module.exports = __webpack_public_path__ + "img/ladder.e8b78da3.png";